<template>
  <div :class="classes" v-bind="$attrs">
    <img :src="logoUrl" />
  </div>
</template>

<script setup lang="ts">
import '../../styles/bonatitan/u-logo.scss'
import { computed } from 'vue'
// template の `<img src="~/...">` は Storybook の browser 環境では解決できないため
// ES import で URL 化して :src に bind する (Nuxt build 上は等価)。
import logoUrl from '~/assets/paylight-logo.png'

const classes = computed(() => {
  return `u-logo`
})
</script>
